export default __webpack_public_path__ + "static/media/car-steering-wheel.dff363a6.svg";